export class UtenteProfilo {
  id: string;
  nome: string;
  cognome: string;
  codiceFiscale: string;
  username: string;
  email: string;
  pec: string;
}
